/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import {getActiveBranchId} from '../utils/branch';
import React,{useState,useEffect,useCallback} from 'react';
import Layout from '../components/layout/Layout';
import api from '../services/api';
import FileShaClaimButton from '../components/common/FileShaClaimButton';
import {fmtDate} from '../utils/helpers';
import {getCurrencySymbol,getCurrencyCode} from '../utils/locale';
import {useTranslation} from 'react-i18next';

const BTN  = "bg-[#039089] hover:bg-teal-700 text-white font-bold py-2 px-4 rounded-xl text-sm transition-all disabled:opacity-50";
const BTN2 = "bg-white hover:bg-slate-50 text-slate-700 font-semibold py-2 px-4 rounded-xl text-sm border border-slate-200 transition-all";
const BTND = "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-xl text-sm transition-all";
const INP  = "w-full bg-white border-2 border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-[#039089] transition-all";
const LBL  = "block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5";
const CARD = "bg-white rounded-2xl border border-slate-200 shadow-sm";
const STATUS_CSS:Record<string,string>={AUTHORIZED:'bg-blue-100 text-[#02357A]',DISPENSED:'bg-green-100 text-green-700',PENDING_BILLING:'bg-amber-100 text-amber-700',CANCELLED:'bg-red-100 text-red-700',ACTIVE:'bg-blue-50 text-blue-700',PENDING:'bg-amber-100 text-amber-700',RECEIVED:'bg-green-100 text-green-700'};

function termHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('accessToken')}`, 'Content-Type': 'application/json' };
}

function DhaGenericMap({ localCode, localCodeAlt, localDisplay, notify }: { localCode: string; localCodeAlt?: string; localDisplay?: string; notify: (m: string) => void }) {
  const [q, setQ] = useState('');
  const [hits, setHits] = useState<any[]>([]);
  const [mapped, setMapped] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [expandMeta, setExpandMeta] = useState<any>({});
  const BASE = process.env.REACT_APP_API_URL;
  useEffect(() => {
    fetch(`${BASE}/terminology/dha/mappings?type=MEDICATION&q=${encodeURIComponent(localCode)}`, { headers: termHeaders() })
      .then(r => r.json()).then(r => {
        const rows = Array.isArray(r) ? r : (r.data || []);
        setMapped(rows.find((x: any) => x.localCode === localCode || x.localCode === localCodeAlt) || rows[0] || null);
      }).catch(() => {});
  }, [localCode, localCodeAlt, BASE]);
  const search = async () => {
    if (q.length < 2) return;
    setBusy(true);
    try {
      const r = await fetch(`${BASE}/terminology/dha/catalog?catalog=ge&q=${encodeURIComponent(q)}&count=20`, { headers: termHeaders() });
      const d = await r.json();
      setHits(d.contains || d.data?.contains || []);
      setExpandMeta(d);
    } catch { setHits([]); }
    setBusy(false);
  };
  const save = async (c: any) => {
    setBusy(true);
    try {
      await fetch(`${BASE}/terminology/dha/mappings`, {
        method: 'POST', headers: termHeaders(),
        body: JSON.stringify({
          localSystem: 'drug', localCode, localDisplay,
          targetSystem: c.system, targetCode: c.code, targetDisplay: c.display,
          terminologyType: 'MEDICATION', valueSetUrl: expandMeta.url || expandMeta.system, version: expandMeta.version,
        }),
      });
      if (localCodeAlt) {
        await fetch(`${BASE}/terminology/dha/mappings`, {
          method: 'POST', headers: termHeaders(),
          body: JSON.stringify({
            localSystem: 'drug_code', localCode: localCodeAlt, localDisplay,
            targetSystem: c.system, targetCode: c.code, targetDisplay: c.display,
            terminologyType: 'MEDICATION',
          }),
        });
      }
      setMapped({ targetCode: c.code, targetDisplay: c.display, targetSystem: c.system, status: 'ACTIVE' });
      notify('DHA generic product mapped');
      // allow parent list refresh via custom event
      window.dispatchEvent(new CustomEvent('dha-ge-mapped'));
    } catch (e: any) { notify(e.message || 'Mapping failed (admin only)'); }
    setBusy(false);
  };
  return (
    <div className="col-span-2 mt-3 border-t pt-3 space-y-2">
      <p className="text-xs font-bold text-slate-600 uppercase">DHA Generic Product (GE*)</p>
      {mapped ? (
        <p className="text-xs text-slate-700">Mapped: <span className="font-mono font-bold">{mapped.targetCode}</span> {mapped.targetDisplay} <span className="text-slate-400">({mapped.status || 'ACTIVE'})</span></p>
      ) : <p className="text-xs text-amber-700">Not mapped — SHR MedicationRequest needs a Generic Products (GE*) code.</p>}
      <div className="flex gap-2">
        <input className={INP} placeholder="Search GE catalog (metformin, GE…)" value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') search(); }} />
        <button type="button" className={BTN2} disabled={busy} onClick={search}>{busy ? '…' : 'Search'}</button>
      </div>
      {hits.map((c: any) => (
        <button type="button" key={c.code} className="block w-full text-left text-xs p-2 rounded-lg border hover:bg-slate-50" onClick={() => save(c)}>
          <span className="font-mono font-bold text-[#02357A]">{c.code}</span> {c.display}
        </button>
      ))}
    </div>
  );
}

const TABS=[
  ['orders','📋 Orders'],['stock','📦 Stock'],['drugs','💊 Drugs'],
  ['purchase','🛒 Purchase Orders'],['returns','↩️ Returns'],
  ['expiry','⚠️ Expiry Alerts'],['dispense','📋 History'],['sale','🛒 New Sale'],
];

export default function PharmacyPage(){
  const {t}=useTranslation();
  const [tab,setTab]=useState('orders');
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const [search,setSearch]=useState('');
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  // Data states
  const [orders,setOrders]=useState<any[]>([]);
  const [drugs,setDrugs]=useState<any[]>([]);
  const [batches,setBatches]=useState<any[]>([]);
  const [expiringBatches,setExpiringBatches]=useState<any[]>([]);
  const [purchaseOrders,setPurchaseOrders]=useState<any[]>([]);
  const [returns,setReturns]=useState<any[]>([]);
  const [dispenseHistory,setDispenseHistory]=useState<any[]>([]);
  const [stats,setStats]=useState<any>({});

  // Dispense panel
  const [showDispense,setShowDispense]=useState(false);
  const [selOrder,setSelOrder]=useState<any>(null);
  const [dispBatches,setDispBatches]=useState<any[]>([]);
  const [dispForm,setDispForm]=useState<any>({batchId:'',quantityDispensed:1,notes:''});

  // Drug form
  const [showDrugForm,setShowDrugForm]=useState(false);
  const [editDrugId,setEditDrugId]=useState<string|null>(null);
  const [drugForm,setDrugForm]=useState<any>({name:'',genericName:'',drugCode:'',category:'',dosageForm:'Tablet',strength:'',mrp:'',sellingPrice:'',reorderLevel:20,prescriptionRequired:false,isNarcotic:false});

  // Purchase Order form
  const [showPOForm,setShowPOForm]=useState(false);
  const [poForm,setPoForm]=useState<any>({supplierName:'',expectedDate:'',notes:'',items:[{drugId:'',itemName:'',quantity:1,unitPrice:0,batchNumber:'',expiryDate:''}]});
  const [showReceivePO,setShowReceivePO]=useState(false);
  const [selPO,setSelPO]=useState<any>(null);

  // Return form
  const [showReturnForm,setShowReturnForm]=useState(false);
  const [returnForm,setReturnForm]=useState<any>({patientId:'',drugName:'',batchId:'',quantityReturned:1,returnReason:'',returnToStock:true});

  // Stock adjust
  const [showAdjust,setShowAdjust]=useState(false);
  const [adjForm,setAdjForm]=useState<any>({drugId:'',batchId:'',quantityChange:0,adjustmentReason:'CORRECTION',notes:''});

  // OTC Sale
  const [saleItems,setSaleItems]=useState<any[]>([{drugId:'',drugName:'',quantity:1,unitPrice:0}]);
  const [salePatient,setSalePatient]=useState('');
  const [drugGeMaps,setDrugGeMaps]=useState<Record<string,any>>({});

  const load=useCallback(async()=>{
    setLoading(true);
    try{
      const [s,o,d]=await Promise.all([
        api.getPharmacyStats?.().catch(()=>({data:{}})),
        api.getPharmacyOrders?.({status:'AUTHORIZED',take:100}).catch(()=>({data:[]})),
        api.getDrugs?.({take:200}).catch(()=>({data:{}})),
      ]);
      setStats(s?.data||{});
      setOrders(Array.isArray(o?.data)?o.data:Array.isArray(o?.data?.data)?o.data.data:[]);
      setDrugs(Array.isArray(d?.data?.drugs)?d.data.drugs:Array.isArray(d?.data?.data)?d.data.data:Array.isArray(d?.data)?d.data:[]);
    }catch{}
    setLoading(false);
  },[]);

  const loadDrugGeMaps=useCallback(async()=>{
    const BASE=process.env.REACT_APP_API_URL;
    try{
      const r=await fetch(`${BASE}/terminology/dha/mappings?type=MEDICATION`,{headers:termHeaders()});
      const raw=await r.json();
      const rows=Array.isArray(raw)?raw:(raw.data||[]);
      const byLocal:Record<string,any>={};
      for(const m of rows){
        if(m.status&&m.status!=='ACTIVE') continue;
        if(m.localCode) byLocal[m.localCode]=m;
      }
      setDrugGeMaps(byLocal);
    }catch{setDrugGeMaps({});}
  },[]);

  const loadTab=useCallback(async()=>{
    if(tab==='drugs') await loadDrugGeMaps();
    if(tab==='stock'){
      const r=await (api as any).get?.('/pharmacy/batches').catch(()=>({data:[]}));
      setBatches(Array.isArray(r?.data)?r.data:Array.isArray(r?.data?.data)?r.data.data:[]);
    }
    if(tab==='expiry'){
      const r=await (api as any).get?.('/pharmacy/batches/expiring?days=90').catch(()=>({data:[]}));
      setExpiringBatches(Array.isArray(r?.data)?r.data:[]);
    }
    if(tab==='purchase'){
      const r=await (api as any).get?.('/pharmacy/purchase-orders').catch(()=>({data:{}}));
      setPurchaseOrders(Array.isArray(r?.data?.orders)?r.data.orders:Array.isArray(r?.data)?r.data:[]);
    }
    if(tab==='returns'){
      const r=await api.getPharmacyReturns?.().catch(()=>({data:[]}));
      setReturns(Array.isArray(r?.data)?r.data:[]);
    }
    if(tab==='dispense'){
      const r=await (api as any).get?.('/pharmacy/dispense?take=50').catch(()=>({data:{}}));
      setDispenseHistory(Array.isArray(r?.data?.records)?r.data.records:Array.isArray(r?.data)?r.data:[]);
    }
  },[tab,loadDrugGeMaps]);

  useEffect(()=>{load();},[load]);
  useEffect(()=>{loadTab();},[loadTab]);
  useEffect(()=>{
    const onMap=()=>{loadDrugGeMaps();};
    window.addEventListener('dha-ge-mapped', onMap);
    return ()=>window.removeEventListener('dha-ge-mapped', onMap);
  },[loadDrugGeMaps]);

  const openDispense=async(order:any)=>{
    setSelOrder(order);
    setDispForm({batchId:'',quantityDispensed:order.quantity||1,notes:''});
    const drugId=order.drug_id||order.drugId;
    if(drugId){
      const r=await api.getDrugBatches?.(drugId,'FEFO').catch(()=>({data:[]}));
      setDispBatches(Array.isArray(r?.data)?r.data:Array.isArray(r?.data?.data)?r.data.data:[]);
    }
    setShowDispense(true);
  };

  const dispense=async()=>{
    if(!selOrder||!dispForm.batchId){notify('⚠️ Select a batch');return;}
    setSaving(true);
    try{
      await api.dispenseOrder?.({orderId:selOrder.id,...dispForm,patientId:selOrder.patient_id||selOrder.patientId,drugId:selOrder.drug_id||selOrder.drugId,drugName:selOrder.item_name||selOrder.drugName,salePrice:selOrder.unit_price||selOrder.unitPrice,quantityDispensed:dispForm.quantityDispensed||selOrder.quantity||1});
      notify('✅ Dispensed!');setShowDispense(false);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const quickDispense=async(order:any)=>{
    setSaving(true);
    try{await api.quickDispense?.({orderId:order.id,quantity:order.quantity||1,drugId:order.drug_id||order.drugId});notify('✅ Quick Dispensed!');await load();}
    catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const saveDrug=async()=>{
    if(!drugForm.name){notify('Drug name required');return;}
    setSaving(true);
    try{
      if(editDrugId)await api.updateDrug?.(editDrugId,drugForm);
      else await api.createDrug?.(drugForm);
      notify('✅ Drug saved!');setShowDrugForm(false);setEditDrugId(null);await load();await loadDrugGeMaps();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const savePO=async()=>{
    setSaving(true);
    try{
      await (api as any).post?.('/pharmacy/purchase-orders',{...poForm,branchId:getActiveBranchId()});
      notify('✅ Purchase order created!');setShowPOForm(false);await loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const receivePO=async()=>{
    if(!selPO)return;setSaving(true);
    try{
      await (api as any).post?.(`/pharmacy/purchase-orders/${selPO.id}/receive`,{items:selPO.items});
      notify('✅ PO received — stock updated!');setShowReceivePO(false);setSelPO(null);await loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const saveReturn=async()=>{
    setSaving(true);
    try{
      await (api as any).post?.('/pharmacy/returns/customer',returnForm);
      notify('✅ Return processed!');setShowReturnForm(false);await loadTab();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const saveAdj=async()=>{
    setSaving(true);
    try{await api.adjustStock?.(adjForm);notify('✅ Stock adjusted!');setShowAdjust(false);await load();}
    catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const filteredOrders=orders.filter((o:any)=>!search||`${o.patient_first_name||''} ${o.first_name||''} ${o.item_name||''} ${o.uhid||''}`.toLowerCase().includes(search.toLowerCase()));
  const filteredDrugs=drugs.filter((d:any)=>!search||(d.name||d.drug_name||'').toLowerCase().includes(search.toLowerCase())||(d.genericName||d.generic_name||'').toLowerCase().includes(search.toLowerCase()));

  return(
    <Layout title="Pharmacy" actions={
      <div className="flex gap-2 flex-wrap">
        {tab==='drugs'&&<><button onClick={()=>{setEditDrugId(null);setDrugForm({name:'',genericName:'',drugCode:'',category:'',dosageForm:'Tablet',strength:'',mrp:'',sellingPrice:'',reorderLevel:20,prescriptionRequired:false,isNarcotic:false});setShowDrugForm(true);}} className={BTN}>+ Add Drug</button></>}
        {tab==='purchase'&&<button onClick={()=>{setPoForm({supplierName:'',expectedDate:'',notes:'',items:[{drugId:'',itemName:'',quantity:1,unitPrice:0,batchNumber:'',expiryDate:''}]});setShowPOForm(true);}} className={BTN}>+ New PO</button>}
        {tab==='returns'&&<button onClick={()=>{setReturnForm({patientId:'',drugName:'',batchId:'',quantityReturned:1,returnReason:'',returnToStock:true});setShowReturnForm(true);}} className={BTN}>+ Process Return</button>}
        {tab==='stock'&&<button onClick={()=>setShowAdjust(true)} className={BTN2}>📦 Adjust Stock</button>}
        {tab==='sale'&&<button onClick={()=>{setSaleItems([{drugId:'',drugName:'',quantity:1,unitPrice:0}]);setSalePatient('');}} className={BTN}>🔄 New Sale</button>}
      </div>
    }>
      {msg&&<div className={`fixed top-4 right-4 z-50 px-4 py-3 rounded-xl text-sm shadow-xl border ${msg.startsWith('✅')?'bg-green-50 text-green-700 border-green-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-4">
        {[
          ['Pending Orders',orders.length,'text-blue-600'],
          ['Total Drugs',stats.totalDrugs||drugs.length,'text-slate-700'],
          ['Low Stock',stats.lowStockCount||0,'text-red-600'],
          ['Expiring (30d)',stats.expiringBatches||0,'text-amber-600'],
          ['Today Revenue',getCurrencySymbol()+' '+(stats.todayRevenue||0),'text-green-600'],
        ].map(([l,v,c])=>(
          <div key={String(l)} className={CARD+' p-3 text-center'}>
            <p className="text-xs text-slate-400">{l}</p>
            <p className={`text-xl font-bold mt-1 ${c}`}>{v}</p>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 bg-slate-100 rounded-xl p-1 overflow-x-auto">
        {TABS.map(([key,label])=>(
          <button key={key} onClick={()=>setTab(key)} className={`flex-shrink-0 text-sm py-2 px-3 rounded-lg transition-all ${tab===key?'bg-white shadow font-semibold text-[#02357A]':'text-slate-600 hover:text-slate-800'}`}>{label}</button>
        ))}
      </div>

      {['orders','drugs','stock','dispense'].includes(tab)&&(
        <input className={INP+' mb-3'} placeholder="🔍 Search..." value={search} onChange={e=>setSearch(e.target.value)}/>
      )}

      {/* ── ORDERS ── */}
      {tab==='orders'&&(
        <div className={CARD+' overflow-hidden'}>
          <div className="grid grid-cols-8 p-3 bg-slate-50 border-b text-xs font-bold text-slate-500 uppercase gap-2">
            <span className="col-span-2">{t('common.patient','Patient')}</span><span className="col-span-2">Drug</span><span>Qty</span><span>{t('common.doctor','Doctor')}</span><span>{t('common.status','Status')}</span><span>{t('common.actions','Actions')}</span>
          </div>
          {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
          :filteredOrders.length===0?<div className="p-8 text-center text-slate-400">No pending orders</div>
          :<div className="divide-y max-h-[60vh] overflow-y-auto">
            {filteredOrders.map((o:any)=>(
              <div key={o.id} className="grid grid-cols-8 gap-2 p-3 items-center hover:bg-slate-50 text-sm">
                <div className="col-span-2"><p className="font-medium">{o.patient_first_name||o.first_name} {o.patient_last_name||o.last_name}</p><p className="text-xs font-mono text-[#02357A]">{o.uhid}</p></div>
                <div className="col-span-2"><p className="font-medium">{o.item_name}</p><p className="text-xs text-slate-400">{o.dosage||o.instructions||''}</p></div>
                <span className="font-semibold">{o.quantity||1}</span>
                <span className="text-xs text-slate-500">{o.doctor_first_name?`Dr.${o.doctor_first_name[0]}.${o.doctor_last_name||''}`:''}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_CSS[o.status]||'bg-slate-100 text-slate-500'}`}>{o.status}</span>
                <div className="flex gap-1 flex-wrap">
                  <button onClick={()=>openDispense(o)} className="text-xs text-[#02357A] hover:underline">Dispense</button>
                  <button onClick={()=>quickDispense(o)} disabled={saving} className="text-xs text-green-600 hover:underline">Quick</button>
                  {(o.patient_id||o.patientId)&&(
                    <FileShaClaimButton
                      patientId={o.patient_id||o.patientId}
                      patientName={`${o.patient_first_name||o.first_name||''} ${o.patient_last_name||o.last_name||''}`.trim()}
                      encounterId={o.id}
                      serviceName={o.item_name||'Pharmacy dispensing'}
                      from="pharmacy"
                      className="text-xs text-purple-700 hover:underline"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>}
        </div>
      )}

      {/* ── STOCK & BATCHES ── */}
      {tab==='stock'&&(
        <div className={CARD+' overflow-hidden'}>
          <div className="p-3 border-b flex justify-between items-center">
            <h3 className="font-semibold text-slate-700">Stock Batches</h3>
            <span className="text-xs text-slate-400">{batches.length} batches</span>
          </div>
          {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
          :batches.length===0?<div className="p-8 text-center text-slate-400">No batches found</div>
          :<div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="bg-slate-50 text-xs text-slate-500 uppercase">
                <th className="px-4 py-2 text-left">Drug</th><th className="px-4 py-2 text-left">Batch #</th><th className="px-4 py-2">Expiry</th><th className="px-4 py-2">Qty</th><th className="px-4 py-2">MRP</th><th className="px-4 py-2">{t('common.status','Status')}</th>
              </tr></thead>
              <tbody className="divide-y">
                {batches.filter((b:any)=>!search||(b.drug_name||b.drugName||'').toLowerCase().includes(search.toLowerCase())).map((b:any)=>{
                  const expiry=new Date(b.expiry_date||b.expiryDate);
                  const daysLeft=Math.ceil((expiry.getTime()-Date.now())/86400000);
                  return(
                    <tr key={b.id} className="hover:bg-slate-50">
                      <td className="px-4 py-2.5 font-medium">
                      {b.drug_name||b.drugName||(drugs.find((d:any)=>d.id===(b.drugId||b.drug_id))?.name)||b.drugId?.slice(-8)||'—'}
                    </td>
                      <td className="px-4 py-2.5 font-mono text-xs">{b.batch_number||b.batchNumber}</td>
                      <td className="px-4 py-2.5 text-center"><span className={`text-xs px-2 py-0.5 rounded-full ${daysLeft<30?'bg-red-100 text-red-700':daysLeft<90?'bg-amber-100 text-amber-700':'bg-green-100 text-green-700'}`}>{fmtDate(b.expiry_date||b.expiryDate)}</span></td>
                      <td className="px-4 py-2.5 text-center font-semibold">{b.available_quantity||b.availableQuantity||b.quantity}</td>
                      <td className="px-4 py-2.5 text-center">{getCurrencySymbol()} {b.mrp||0}</td>
                      <td className="px-4 py-2.5 text-center"><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_CSS[b.status]||'bg-slate-100 text-slate-500'}`}>{b.status||'ACTIVE'}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>}
        </div>
      )}

      {/* ── DRUGS ── */}
      {tab==='drugs'&&(
        <div className={CARD+' overflow-hidden'}>
          <div className="px-4 py-2 border-b bg-slate-50 text-[11px] text-slate-500">
            DHA GE* mapping is required for SHR MedicationRequest. Edit a drug to search the Generic Products master and save a mapping.
          </div>
          <div className="overflow-x-auto max-h-[65vh]">
            {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
            :<table className="w-full text-sm">
              <thead className="sticky top-0 bg-slate-50"><tr className="text-xs text-slate-500 uppercase border-b">
                <th className="px-4 py-2 text-left">{t('common.code','Code')}</th><th className="px-4 py-2 text-left">Drug Name</th><th className="px-4 py-2 text-left">Generic</th><th className="px-4 py-2 text-left">DHA GE</th><th className="px-4 py-2">Form</th><th className="px-4 py-2">Stock</th><th className="px-4 py-2">MRP</th><th className="px-4 py-2">{t('common.actions','Actions')}</th>
              </tr></thead>
              <tbody className="divide-y">
                {filteredDrugs.map((d:any)=>{
                  const ge=drugGeMaps[d.id]||drugGeMaps[d.drugCode]||drugGeMaps[d.drug_code];
                  return (
                  <tr key={d.id} className="hover:bg-slate-50">
                    <td className="px-4 py-2.5 font-mono text-xs text-[#02357A]">{d.drugCode||d.drug_code}</td>
                    <td className="px-4 py-2.5"><p className="font-medium">{d.name||d.drug_name}</p><p className="text-xs text-slate-400">{d.strength}</p></td>
                    <td className="px-4 py-2.5 text-xs text-slate-500">{d.genericName||d.generic_name||'—'}</td>
                    <td className="px-4 py-2.5 text-xs">
                      {ge ? (
                        <span className="font-mono text-teal-800" title={ge.targetDisplay}>{ge.targetCode}</span>
                      ) : (
                        <span className="text-amber-600 font-semibold">Unmapped</span>
                      )}
                    </td>
                    <td className="px-4 py-2.5 text-center text-xs">{d.dosageForm||d.form||'—'}</td>
                    <td className="px-4 py-2.5 text-center"><span className={`font-bold text-sm ${(+d.totalStock||0)<=(+d.reorderLevel||0)?'text-red-600':'text-green-600'}`}>{d.totalStock||0}</span></td>
                    <td className="px-4 py-2.5 text-center text-sm">{getCurrencySymbol()} {d.mrp||d.sellingPrice||0}</td>
                    <td className="px-4 py-2.5">
                      <div className="flex gap-2">
                        <button onClick={()=>{setEditDrugId(d.id);setDrugForm({name:d.name||d.drug_name,genericName:d.genericName||d.generic_name||'',drugCode:d.drugCode||d.drug_code||'',category:d.category||'',dosageForm:d.dosageForm||d.form||'Tablet',strength:d.strength||'',mrp:d.mrp||'',sellingPrice:d.sellingPrice||d.selling_price||'',reorderLevel:d.reorderLevel||20,prescriptionRequired:d.prescriptionRequired||false,isNarcotic:d.isNarcotic||false});setShowDrugForm(true);}} className="text-xs text-[#02357A] hover:underline">{t('common.edit','Edit')}</button>
                        <button onClick={()=>{setAdjForm({drugId:d.id,batchId:'',quantityChange:0,adjustmentReason:'CORRECTION',notes:''});setShowAdjust(true);}} className="text-xs text-amber-600 hover:underline">Adjust</button>
                      </div>
                    </td>
                  </tr>
                  );
                })}
                {filteredDrugs.length===0&&<tr><td colSpan={8} className="text-center py-8 text-slate-400">No drugs found</td></tr>}
              </tbody>
            </table>}
          </div>
        </div>
      )}

      {/* ── PURCHASE ORDERS ── */}
      {tab==='purchase'&&(
        <div className="space-y-4">
          <div className={CARD+' overflow-hidden'}>
            {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
            :purchaseOrders.length===0?<div className="p-8 text-center text-slate-400">No purchase orders</div>
            :<table className="w-full text-sm">
              <thead><tr className="bg-slate-50 text-xs text-slate-500 uppercase border-b">
                <th className="px-4 py-3 text-left">PO #</th><th className="px-4 py-3 text-left">Supplier</th><th className="px-4 py-3">Items</th><th className="px-4 py-3">{t('common.total','Total')}</th><th className="px-4 py-3">{t('common.status','Status')}</th><th className="px-4 py-3">{t('common.actions','Actions')}</th>
              </tr></thead>
              <tbody className="divide-y">
                {purchaseOrders.map((po:any)=>(
                  <tr key={po.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono text-xs text-[#02357A]">{po.poNumber||po.po_number}</td>
                    <td className="px-4 py-3 font-medium">{po.supplierName||po.supplier_name||'—'}</td>
                    <td className="px-4 py-3 text-center">{(po.items||[]).length}</td>
                    <td className="px-4 py-3 text-center font-semibold">{getCurrencySymbol()} {(+po.totalAmount||+po.total_amount||0).toLocaleString()}</td>
                    <td className="px-4 py-3 text-center"><span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_CSS[po.status]||'bg-slate-100 text-slate-500'}`}>{po.status}</span></td>
                    <td className="px-4 py-3">
                      {po.status==='PENDING'&&<button onClick={()=>{setSelPO(po);setShowReceivePO(true);}} className="text-xs text-green-600 hover:underline font-semibold">Receive →</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>}
          </div>
        </div>
      )}

      {/* ── RETURNS ── */}
      {tab==='returns'&&(
        <div className={CARD+' overflow-hidden'}>
          <div className="p-4 border-b flex justify-between items-center">
            <h3 className="font-semibold text-slate-700">Customer Returns</h3>
            <span className="text-xs text-slate-400">{returns.length} records</span>
          </div>
          {returns.length===0?<div className="p-8 text-center text-slate-400"><p className="text-3xl mb-2">↩️</p><p>No returns recorded</p></div>
          :<div className="divide-y max-h-[60vh] overflow-y-auto">
            {returns.map((r:any,i:number)=>(
              <div key={r.id||i} className="p-4 flex justify-between items-center text-sm hover:bg-slate-50">
                <div>
                  <p className="font-medium">{r.drugName||r.drug_name||r.returnNumber||'Return'}</p>
                  <p className="text-xs text-slate-400">{r.returnReason||r.return_reason||'—'} · Qty: {r.quantityReturned||r.quantity_returned}</p>
                </div>
                <div className="text-right">
                  <p className={`text-xs font-semibold ${r.returnToStock?'text-green-600':'text-slate-400'}`}>{r.returnToStock?'Returned to Stock':'Disposed'}</p>
                  <p className="text-xs text-slate-400">{r.createdAt?new Date(r.createdAt).toLocaleDateString('en-KE'):'—'}</p>
                </div>
              </div>
            ))}
          </div>}
        </div>
      )}

      {/* ── EXPIRY ALERTS ── */}
      {tab==='expiry'&&(
        <div className="space-y-3">
          <div className="flex gap-3">
            {[30,60,90].map(d=>(
              <button key={d} onClick={async()=>{
                const r=await (api as any).get?.(`/pharmacy/batches/expiring?days=${d}`).catch(()=>({data:[]}));
                setExpiringBatches(Array.isArray(r?.data)?r.data:[]);
              }} className={BTN2+' text-xs'}>Expiring in {d}d</button>
            ))}
          </div>
          {expiringBatches.length===0?<div className={CARD+' p-8 text-center text-slate-400'}><p className="text-3xl mb-2">✅</p><p>No expiring batches</p></div>
          :<div className={CARD+' overflow-hidden'}>
            <table className="w-full text-sm">
              <thead><tr className="bg-slate-50 text-xs text-slate-500 uppercase border-b">
                <th className="px-4 py-2 text-left">Drug</th><th className="px-4 py-2">Batch #</th><th className="px-4 py-2">Expiry</th><th className="px-4 py-2">Qty</th><th className="px-4 py-2">Days Left</th>
              </tr></thead>
              <tbody className="divide-y">
                {expiringBatches.map((b:any)=>{
                  const expiry=new Date(b.expiry_date||b.expiryDate);
                  const days=Math.ceil((expiry.getTime()-Date.now())/86400000);
                  return(
                    <tr key={b.id} className="hover:bg-slate-50">
                      <td className="px-4 py-2.5 font-medium">{b.drug_name||b.drugName||'—'}</td>
                      <td className="px-4 py-2.5 text-center font-mono text-xs">{b.batch_number||b.batchNumber}</td>
                      <td className="px-4 py-2.5 text-center">{fmtDate(b.expiry_date||b.expiryDate)}</td>
                      <td className="px-4 py-2.5 text-center">{b.available_quantity||b.availableQuantity}</td>
                      <td className="px-4 py-2.5 text-center"><span className={`text-xs font-bold px-2 py-0.5 rounded-full ${days<0?'bg-red-200 text-red-800':days<30?'bg-red-100 text-red-700':'bg-amber-100 text-amber-700'}`}>{days<0?'EXPIRED':`${days}d`}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>}
        </div>
      )}

      {/* ── DISPENSE HISTORY ── */}
      {tab==='dispense'&&(
        <div className={CARD+' overflow-hidden'}>
          {loading?<div className="p-8 text-center text-slate-400">Loading...</div>
          :dispenseHistory.length===0?<div className="p-8 text-center text-slate-400">No dispense history</div>
          :<div className="divide-y max-h-[60vh] overflow-y-auto">
            {dispenseHistory.filter((d:any)=>!search||(d.drugName||d.drug_name||'').toLowerCase().includes(search.toLowerCase())).map((d:any,i:number)=>(
              <div key={d.id||i} className="p-3 flex justify-between items-center text-sm hover:bg-slate-50">
                <div>
                  <p className="font-medium">{d.drugName||d.drug_name||d.dispenseNumber||'Dispense'}</p>
                  <p className="text-xs text-slate-400">Qty: {d.quantityDispensed||d.quantity_dispensed} · {d.dispenseNumber||d.dispense_number}</p>
                </div>
                <p className="text-xs text-slate-400">{d.dispenseDate||d.dispense_date||d.createdAt?new Date(d.dispenseDate||d.dispense_date||d.createdAt).toLocaleDateString('en-KE'):'—'}</p>
              </div>
            ))}
          </div>}
        </div>
      )}

      {/* ── OTC SALE ── */}
      {tab==='sale'&&(
        <div className="max-w-2xl space-y-3">
          <h3 className="font-semibold text-slate-700 border-b pb-2">OTC / Walk-in Sale</h3>
          <div><label className={LBL}>Patient ID (optional)</label><input className={INP} value={salePatient} onChange={e=>setSalePatient(e.target.value)} placeholder="Leave empty for walk-in"/></div>
          <p className="text-xs font-bold text-slate-500 uppercase">Items</p>
          {saleItems.map((item,i)=>(
            <div key={i} className="grid grid-cols-5 gap-2 items-end">
              <div className="col-span-2">
                <label className={LBL}>Drug</label>
                <select className={INP} value={item.drugId} onChange={e=>{const d=drugs.find((dr:any)=>dr.id===e.target.value);setSaleItems(s=>s.map((it,idx)=>idx===i?{...it,drugId:e.target.value,drugName:d?.name||d?.drug_name||'',unitPrice:parseFloat(d?.mrp||d?.sellingPrice||0)}:it));}}>
                  <option value="">Select drug...</option>
                  {drugs.map((d:any)=><option key={d.id} value={d.id}>{d.name||d.drug_name} {d.strength}</option>)}
                </select>
              </div>
              <div><label className={LBL}>Qty</label><input className={INP} type="number" min="1" value={item.quantity} onChange={e=>setSaleItems(s=>s.map((it,idx)=>idx===i?{...it,quantity:+e.target.value}:it))}/></div>
              <div><label className={LBL}>Price ({getCurrencyCode()})</label><input className={INP} type="number" value={item.unitPrice} onChange={e=>setSaleItems(s=>s.map((it,idx)=>idx===i?{...it,unitPrice:+e.target.value}:it))}/></div>
              <button onClick={()=>setSaleItems(s=>s.filter((_,idx)=>idx!==i))} className="text-red-500 hover:text-red-700 mb-1 font-bold">✕</button>
            </div>
          ))}
          <button onClick={()=>setSaleItems(s=>[...s,{drugId:'',drugName:'',quantity:1,unitPrice:0}])} className={BTN2+' text-xs w-full'}>+ Add Item</button>
          <div className="bg-slate-50 rounded-xl p-3 text-sm font-semibold flex justify-between">
            <span>{t('common.total','Total')}</span><span className="text-[#02357A]">{getCurrencySymbol()} {saleItems.reduce((s,i)=>s+(i.quantity*(i.unitPrice||0)),0).toFixed(2)}</span>
          </div>
          <div className="flex gap-3">
            <button onClick={async()=>{setSaving(true);try{await api.createOtcSale?.({patientId:salePatient||undefined,items:saleItems,branchId:getActiveBranchId()||undefined});notify('✅ Sale completed!');}catch(e:any){notify('❌ Error');}setSaving(false);}} disabled={saving||!saleItems.some(i=>i.drugId)} className={BTN+' flex-1'}>{saving?'Processing...':'Complete Sale'}</button>
          </div>
        </div>
      )}

      {/* ── Dispense Panel ── */}
      {showDispense&&selOrder&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">💊 Dispense</h3><button onClick={()=>setShowDispense(false)} className="text-slate-400 hover:text-slate-700 text-xl">✕</button></div>
          <div className="space-y-3">
            <div className="bg-blue-50 rounded-xl p-3 text-sm">
              <p className="font-semibold">{selOrder.patient_first_name||selOrder.first_name} {selOrder.patient_last_name||selOrder.last_name}</p>
              <p className="text-slate-500">{selOrder.item_name} — Qty: {selOrder.quantity}</p>
            </div>
            <div><label className={LBL}>Select Batch (FEFO) *</label>
              <select className={INP} value={dispForm.batchId} onChange={e=>setDispForm({...dispForm,batchId:e.target.value})}>
                <option value="">Select batch...</option>
                {dispBatches.map((b:any)=><option key={b.id} value={b.id}>Batch {b.batch_number||b.batchNumber} · Exp: {fmtDate(b.expiry_date||b.expiryDate)} · Qty: {b.available_quantity||b.availableQuantity}</option>)}
              </select>
              {dispBatches.length===0&&<p className="text-xs text-amber-600 mt-1">No batches — use Quick Dispense for auto-selection</p>}
            </div>
            <div><label className={LBL}>{t('common.quantity','Quantity')}</label><input className={INP} type="number" min="1" value={dispForm.quantityDispensed} onChange={e=>setDispForm({...dispForm,quantityDispensed:+e.target.value})}/></div>
            <div><label className={LBL}>{t('common.notes','Notes')}</label><input className={INP} value={dispForm.notes} onChange={e=>setDispForm({...dispForm,notes:e.target.value})}/></div>
            <button onClick={dispense} disabled={saving||!dispForm.batchId} className={BTN+' w-full'}>{saving?'Dispensing...':'Confirm Dispense'}</button>
          </div>
        </div>
      </div>}

      {/* ── Drug Form ── */}
      {showDrugForm&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-6 overflow-y-auto max-h-[90vh]">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">{editDrugId?'Edit Drug':'Add Drug'}</h3><button onClick={()=>setShowDrugForm(false)} className="text-slate-400 text-xl">✕</button></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><label className={LBL}>Drug Name *</label><input className={INP} value={drugForm.name} onChange={e=>setDrugForm({...drugForm,name:e.target.value})}/></div>
            <div><label className={LBL}>Drug Code</label><input className={INP} value={drugForm.drugCode} onChange={e=>setDrugForm({...drugForm,drugCode:e.target.value})}/></div>
            <div><label className={LBL}>{t('common.category','Category')}</label><input className={INP} value={drugForm.category} onChange={e=>setDrugForm({...drugForm,category:e.target.value})} placeholder="Antibiotic, Analgesic..."/></div>
            <div><label className={LBL}>Generic Name</label><input className={INP} value={drugForm.genericName} onChange={e=>setDrugForm({...drugForm,genericName:e.target.value})}/></div>
            <div><label className={LBL}>Form</label>
              <select className={INP} value={drugForm.dosageForm} onChange={e=>setDrugForm({...drugForm,dosageForm:e.target.value})}>
                {['Tablet','Capsule','Syrup','Injection','Cream','Drops','Inhaler','Patch','Powder','Other'].map(f=><option key={f}>{f}</option>)}
              </select>
            </div>
            <div><label className={LBL}>Strength</label><input className={INP} value={drugForm.strength} onChange={e=>setDrugForm({...drugForm,strength:e.target.value})} placeholder="500mg, 5ml..."/></div>
            <div><label className={LBL}>MRP ({getCurrencyCode()})</label><input className={INP} type="number" value={drugForm.mrp} onChange={e=>setDrugForm({...drugForm,mrp:e.target.value})}/></div>
            <div><label className={LBL}>Selling Price ({getCurrencyCode()})</label><input className={INP} type="number" value={drugForm.sellingPrice} onChange={e=>setDrugForm({...drugForm,sellingPrice:e.target.value})}/></div>
            <div><label className={LBL}>Reorder Level</label><input className={INP} type="number" value={drugForm.reorderLevel} onChange={e=>setDrugForm({...drugForm,reorderLevel:+e.target.value})}/></div>
            <div className="flex items-center gap-3 mt-2">
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={drugForm.prescriptionRequired} onChange={e=>setDrugForm({...drugForm,prescriptionRequired:e.target.checked})} className="w-4 h-4"/><span>Prescription Required</span></label>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={drugForm.isNarcotic} onChange={e=>setDrugForm({...drugForm,isNarcotic:e.target.checked})} className="w-4 h-4"/><span>Narcotic</span></label>
            </div>
            {editDrugId && <DhaGenericMap localCode={editDrugId} localCodeAlt={drugForm.drugCode} localDisplay={drugForm.name} notify={notify}/>}
          </div>
          <button onClick={saveDrug} disabled={saving} className={BTN+' w-full mt-4'}>{saving?'Saving...':(editDrugId?'Update Drug':'Add Drug')}</button>
        </div>
      </div>}

      {/* ── Purchase Order Form ── */}
      {showPOForm&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl p-6 overflow-y-auto max-h-[90vh]">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">🛒 New Purchase Order</h3><button onClick={()=>setShowPOForm(false)} className="text-slate-400 text-xl">✕</button></div>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div><label className={LBL}>Supplier Name *</label><input className={INP} value={poForm.supplierName} onChange={e=>setPoForm({...poForm,supplierName:e.target.value})}/></div>
              <div><label className={LBL}>Expected Date</label><input className={INP} type="date" value={poForm.expectedDate} onChange={e=>setPoForm({...poForm,expectedDate:e.target.value})}/></div>
            </div>
            <p className="text-xs font-bold text-slate-500 uppercase mt-2">Items</p>
            {poForm.items.map((item:any,i:number)=>(
              <div key={i} className="grid grid-cols-6 gap-2 items-end bg-slate-50 p-2 rounded-xl">
                <div className="col-span-2"><label className={LBL}>Drug</label>
                  <select className={INP} value={item.drugId} onChange={e=>{const d=drugs.find((dr:any)=>dr.id===e.target.value);setPoForm((f:any)=>({...f,items:f.items.map((it:any,idx:number)=>idx===i?{...it,drugId:e.target.value,itemName:d?.name||'',unitPrice:d?.mrp||0}:it)}));}}>
                    <option value="">Select...</option>
                    {drugs.map((d:any)=><option key={d.id} value={d.id}>{d.name||d.drug_name} {d.strength}</option>)}
                  </select>
                </div>
                <div><label className={LBL}>Qty</label><input className={INP} type="number" min="1" value={item.quantity} onChange={e=>setPoForm((f:any)=>({...f,items:f.items.map((it:any,idx:number)=>idx===i?{...it,quantity:+e.target.value}:it)}))}/></div>
                <div><label className={LBL}>{t('common.price','Price')}</label><input className={INP} type="number" value={item.unitPrice} onChange={e=>setPoForm((f:any)=>({...f,items:f.items.map((it:any,idx:number)=>idx===i?{...it,unitPrice:+e.target.value}:it)}))}/></div>
                <div><label className={LBL}>Batch #</label><input className={INP} value={item.batchNumber} onChange={e=>setPoForm((f:any)=>({...f,items:f.items.map((it:any,idx:number)=>idx===i?{...it,batchNumber:e.target.value}:it)}))}/></div>
                <button onClick={()=>setPoForm((f:any)=>({...f,items:f.items.filter((_:any,idx:number)=>idx!==i)}))} className="text-red-500 mb-1 font-bold">✕</button>
              </div>
            ))}
            <button onClick={()=>setPoForm((f:any)=>({...f,items:[...f.items,{drugId:'',itemName:'',quantity:1,unitPrice:0,batchNumber:'',expiryDate:''}]}))} className={BTN2+' text-xs w-full'}>+ Add Item</button>
            <div className="bg-slate-50 rounded-xl p-3 text-sm font-semibold flex justify-between">
              <span>{t('common.total','Total')}</span><span>{getCurrencySymbol()} {poForm.items.reduce((s:number,i:any)=>s+(+i.quantity*(+i.unitPrice||0)),0).toLocaleString()}</span>
            </div>
            <button onClick={savePO} disabled={saving||!poForm.supplierName} className={BTN+' w-full'}>{saving?'Creating...':'Create Purchase Order'}</button>
          </div>
        </div>
      </div>}

      {/* ── Receive PO ── */}
      {showReceivePO&&selPO&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-6 overflow-y-auto max-h-[90vh]">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">📦 Receive PO — {selPO.poNumber||selPO.po_number}</h3><button onClick={()=>setShowReceivePO(false)} className="text-slate-400 text-xl">✕</button></div>
          <div className="space-y-2 mb-4">
            {(selPO.items||[]).map((item:any,i:number)=>(
              <div key={i} className="bg-slate-50 rounded-xl p-3 grid grid-cols-3 gap-2 text-sm">
                <div><p className="font-medium">{item.itemName||item.item_name||'Item '+i}</p><p className="text-xs text-slate-400">Ordered: {item.quantity}</p></div>
                <div><label className={LBL}>Received Qty</label><input className={INP} type="number" defaultValue={item.quantity} onChange={e=>{item.receivedQuantity=+e.target.value;}}/></div>
                <div><label className={LBL}>Expiry Date</label><input className={INP} type="date" defaultValue={item.expiryDate||item.expiry_date||''} onChange={e=>{item.expiryDate=e.target.value;}}/></div>
              </div>
            ))}
          </div>
          <button onClick={receivePO} disabled={saving} className={BTN+' w-full'}>{saving?'Receiving...':'✅ Confirm Receipt — Update Stock'}</button>
        </div>
      </div>}

      {/* ── Return Form ── */}
      {showReturnForm&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">↩️ Process Return</h3><button onClick={()=>setShowReturnForm(false)} className="text-slate-400 text-xl">✕</button></div>
          <div className="space-y-3">
            <div><label className={LBL}>Drug Name</label><input className={INP} value={returnForm.drugName} onChange={e=>setReturnForm({...returnForm,drugName:e.target.value})}/></div>
            <div><label className={LBL}>Quantity Returned</label><input className={INP} type="number" min="1" value={returnForm.quantityReturned} onChange={e=>setReturnForm({...returnForm,quantityReturned:+e.target.value})}/></div>
            <div><label className={LBL}>Return Reason</label><input className={INP} value={returnForm.returnReason} onChange={e=>setReturnForm({...returnForm,returnReason:e.target.value})} placeholder="Wrong drug, expired, patient refused..."/></div>
            <div><label className={LBL}>Patient ID (optional)</label><input className={INP} value={returnForm.patientId} onChange={e=>setReturnForm({...returnForm,patientId:e.target.value})}/></div>
            <label className="flex items-center gap-2 text-sm cursor-pointer">
              <input type="checkbox" checked={returnForm.returnToStock} onChange={e=>setReturnForm({...returnForm,returnToStock:e.target.checked})} className="w-4 h-4"/>
              <span>Return drug to stock</span>
            </label>
            <button onClick={saveReturn} disabled={saving} className={BTN+' w-full'}>{saving?'Processing...':'Process Return'}</button>
          </div>
        </div>
      </div>}

      {/* ── Stock Adjust ── */}
      {showAdjust&&<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">
          <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">📦 Stock Adjustment</h3><button onClick={()=>setShowAdjust(false)} className="text-slate-400 text-xl">✕</button></div>
          <div className="space-y-3">
            <div><label className={LBL}>Drug *</label>
              <select className={INP} value={adjForm.drugId} onChange={e=>setAdjForm({...adjForm,drugId:e.target.value})}>
                <option value="">Select drug...</option>
                {drugs.map((d:any)=><option key={d.id} value={d.id}>{d.name||d.drug_name}</option>)}
              </select>
            </div>
            <div><label className={LBL}>Qty Change * <span className="font-normal normal-case text-slate-400">(+ add / - remove)</span></label><input className={INP} type="number" value={adjForm.quantityChange} onChange={e=>setAdjForm({...adjForm,quantityChange:+e.target.value})}/></div>
            <div><label className={LBL}>{t('common.reason','Reason')}</label>
              <select className={INP} value={adjForm.adjustmentReason} onChange={e=>setAdjForm({...adjForm,adjustmentReason:e.target.value})}>
                {['CORRECTION','DAMAGE','EXPIRY','OPENING_STOCK','RETURN','TRANSFER','AUDIT'].map(r=><option key={r}>{r}</option>)}
              </select>
            </div>
            <div><label className={LBL}>{t('common.notes','Notes')}</label><input className={INP} value={adjForm.notes} onChange={e=>setAdjForm({...adjForm,notes:e.target.value})}/></div>
            <button onClick={saveAdj} disabled={saving||!adjForm.drugId||!adjForm.quantityChange} className={BTN+' w-full'}>{saving?'Saving...':'Save Adjustment'}</button>
          </div>
        </div>
      </div>}
    </Layout>
  );
}
